import {useEffect, useState} from "react";
import axios from "axios";
import {PATHS_API} from "../../../enum";
import {useServersStore} from "../../../modules/shop/servers/store";

interface IAdminServer {
    _id: string,
    name: string,
    lootboxDisabled?: boolean,
}

// Ящик удачі по серверах: вимкнений сервер зникає зі сторінки ящика, а відкрити ящик на нього не дасть сервер
const LootboxServers = ({ onDone }: { onDone: (message: string, type?: "success" | "error") => void }) => {
    const [servers, setServers] = useState<IAdminServer[]>([]);
    const [saving, setSaving] = useState<string | null>(null);
    const fetchServers = useServersStore((s) => s.fetchServers);

    useEffect(() => {
        axios.get(PATHS_API.ADMIN_SERVERS, { withCredentials: true })
            .then(({ data }) => setServers(data))
            .catch(() => {});
    }, []);

    const toggle = async (server: IAdminServer) => {
        const enabled = !!server.lootboxDisabled;
        setSaving(server._id);
        try {
            const { data } = await axios.put(`${PATHS_API.ADMIN_SERVERS}/${server._id}/lootbox`, { enabled }, { withCredentials: true });
            setServers((list) => list.map((s) => s._id === data._id ? data : s));
            fetchServers(); // сторінка ящика в цій вкладці теж одразу побачить зміну
            onDone(`Ящик удачі на ${server.name} ${enabled ? "увімкнено" : "вимкнено"}`);
        } catch (err: any) {
            onDone(err.response?.data?.message || "Не вдалося змінити налаштування", "error");
        } finally {
            setSaving(null);
        }
    };

    if (!servers.length) return null;

    return (
        <div className="adm-lootbox">
            <div className="adm-lootbox-title">
                <b>Ящик удачі на серверах</b>
                <span>Вимкнений сервер зникне зі сторінки ящика, відкрити ящик на нього буде не можна.</span>
            </div>
            <div className="adm-lootbox-list">
                { servers.map((s) =>
                    <label key={s._id} className={`adm-switch ${s.lootboxDisabled ? "" : "on"}`}>
                        <input
                            type="checkbox"
                            checked={!s.lootboxDisabled}
                            disabled={saving === s._id}
                            onChange={() => toggle(s)}
                        />
                        <span className="adm-switch-track" aria-hidden="true"><i /></span>
                        <span className="adm-switch-name">{s.name}</span>
                    </label>
                )}
            </div>
        </div>
    );
};

export default LootboxServers;
